import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { MediaQuery } from '@grandvisionhq/common';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { getLocalizedValue } from '@grandvisionhq/utils';
import { getActiveVariant } from '../../helpers.js';
import { pushPdpEventToDataLayer } from '../../utils/DataLayer/data-layer.js';
import { ReadyReaders } from './ReadyReaders.js';
import { useBrandLink } from '../utils/use-brand-link.js';

const ReadyReadersContainer = ({ activeSku , addToCartRef , formatProductUrl , sizeGuideDocument , handleConversionEvent , handleVariantPick: onVariantPick , onCTAClick , product , productImageGallery , productTypeUsps , showStickyButton , specificationConfiguration , stickyTop , variant , storesRoute  })=>{
    var ref;
    const { currency , getLabel , locale  } = useIntl();
    const { isProductLabelEnabled  } = useFeatureToggles();
    const brandLink = useBrandLink(product);
    const isMobile = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const activeVariant = getActiveVariant(product, activeSku);
    const productImageAlt = getLocalizedValue(product.name, locale);
    var ref1;
    const stockCount = (ref1 = (ref = variant.availability) === null || ref === void 0 ? void 0 : ref.availableQuantity) !== null && ref1 !== void 0 ? ref1 : 0;
    const isOrderable = (variant === null || variant === void 0 ? void 0 : variant.channelAvailability) === 'ONLINE';
    const variants = React.useMemo(()=>[
            product.masterVariant,
            ...product.variants
        ]
    , [
        product.masterVariant,
        product.variants
    ]);
    const handleVariantPick = React.useCallback((selectedSize, ...args)=>{
        onVariantPick(...args);
        DataLayer.pushEvent({
            event: 'readyreaders',
            eventAction: 'pdp select lens power',
            eventLabel: selectedSize
        });
    }, [
        onVariantPick
    ]);
    const labels = React.useMemo(()=>({
            informationBlockHeader: getLabel('products.readyreaders.informationBlockHeader'),
            power: getLabel('products.readyreaders.power')
        })
    , [
        getLabel
    ]);
    React.useEffect(()=>{
        pushPdpEventToDataLayer(DataLayer.DataLayerTypes.PurchaseType.OneTime, product, activeSku, currency);
    }, [
        activeSku
    ]);
    return /*#__PURE__*/ React.createElement(ReadyReaders, {
        activeSku: activeSku,
        activeVariant: activeVariant,
        addToCartRef: addToCartRef,
        brandLink: brandLink,
        currency: currency,
        formatProductUrl: formatProductUrl,
        handleConversionEvent: handleConversionEvent,
        handleVariantPick: handleVariantPick,
        isMobile: isMobile,
        isOrderable: isOrderable,
        isProductLabelEnabled: isProductLabelEnabled,
        labels: labels,
        onCTAClick: onCTAClick,
        product: product,
        productImageAlt: productImageAlt,
        productImageGallery: productImageGallery,
        productTypeUsps: productTypeUsps,
        sizeGuideDocument: sizeGuideDocument,
        showStickyButton: showStickyButton,
        specificationConfiguration: specificationConfiguration,
        stickyTop: stickyTop,
        stockCount: stockCount,
        variant: variant,
        variants: variants,
        storesRoute: storesRoute
    });
};

export { ReadyReadersContainer };
//# sourceMappingURL=ReadyReadersContainer.js.map
